import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RemoteUpdateCustomerMapping } from "../../../data/usecases/customer-database/remote-update-customer-mapping";
import { UpdateCustomerMapping } from "../../../domain/useages/customer-database/update-customer-mapping";
import { FailedCustomerData } from "../../../domain/models/failed-customer-data";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UpdateCustomerMappingInterface {
  updateCustomerMapping: Function;
  handleTransferLoading: Function;
  failedDeactivates: FailedCustomerData[];
}

const initialStates = {
  failedDeactivates: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUpdateCustomerMappingSlice: StateCreator<
  UpdateCustomerMappingInterface
> = (set, get) => ({
  ...initialStates,
  handleTransferLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },

        title: "Please wait... Customer transfer request is sending ",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },

  updateCustomerMapping: async (
    payload: UpdateCustomerMapping.Params,
    index: number,
    loading: boolean
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteUpdateCustomerMapping: UpdateCustomerMapping =
      new RemoteUpdateCustomerMapping(
        `${BASE_URL}${Endpoints.UPDATE_CUSTOMER_MAPPINGS}`,

        axiosHttpClient
      );
    get().handleTransferLoading(loading);
    let response = await remoteUpdateCustomerMapping.update(payload);

    if (response.success) {
      return response;
    } else {
      let failedUpdate = [
        ...get().failedDeactivates,
        {
          id: index,
          reason: response.errors.message
            ? response.errors.message
            : response.message,
        },
      ];

      set(() => ({
        failedDeactivates: failedUpdate,
      }));
      return response;
    }
  },
});
